let APP_URL = '';

if (process.env.NODE_ENV === 'production') {
  APP_URL = `${process.env.REACT_APP_PROD_URL}`;
} else {
  APP_URL = `${process.env.REACT_APP_STAGING_URL}`;
}

export const SERVER_URL = APP_URL;
